export default [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/modules/citizen/pages/HomePage.vue"),
    meta: {
      breadcrumb: [{label: "Dashboard"}],
      requireLogin: true,
      layout: 'App',
      module: 'DashboardCitizen'
    },
  },

  {
    path: "/profile/",
    name: "ProfilePage",
    component: () => import("@/modules/citizen/pages/user/Profile.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}],
      requireLogin: true,
      layout: 'App',
      module: 'CitizenProfile',
      requiredRight: 'view'
    }
  },

  {
    path: "/login/",
    name: "Login",
    component: () => import("@/modules/citizen/pages/user/Login.vue"),
    meta: {
      breadcrumb: [{label: "Login"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/create-account/",
    name: "Register",
    component: () => import("@/modules/citizen/pages/user/Register.vue"),
    meta: {
      breadcrumb: [{label: "Create account"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/recover-password/",
    name: "RecoverPassword",
    component: () => import("@/modules/citizen/pages/user/RecoverPassword.vue"),
    meta: {
      breadcrumb: [{label: "Recover password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/reset-password/",
    name: "ResetPassword",
    component: () => import("@/modules/citizen/pages/user/ResetPassword.vue"),
    meta: {
      breadcrumb: [{label: "Reset password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/embed/",
    name: "Embed",
    component: () => import("@/pages/EmbedPage.vue"),
    meta: {
      requireLogin: false,
      layout: 'App',
      module: 'layer',
      requiredRight: 'view'
    },
  },

  {
    path: "/page/:formId/:slug?",
    name: "FormRender",
    component: () => import("@/pages/documents/FormRenderPage.vue"),
    meta: {
      breadcrumb: [{label: "Form Page"}],
      requireLogin: false,
      layout: 'App'
    }
  },

  {
    path: "/dashboard/:moduleCode",
    name: "ModuleDashboard",
    component: () => import("@/pages/ModuleDashboardPage.vue"),
    meta: {
      breadcrumb: [{label: "Module Dashboard Page"}],
      requireLogin: true,
      layout: 'App'
    }
  },

  {
    path: "/my-institutions/",
    name: "MyInstitutions",
    component: () => import("@/modules/citizen/pages/user/Institutions.vue"),
    meta: {
      breadcrumb: [{label: "My Institutions"}],
      requireLogin: true,
      layout: 'App',
      module: 'CitizenOrganizations',
    }
  },
  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/layout/NotFound.vue"),
    meta: {
      requireLogin: false,
      layout: 'NotFound'
    },
  },
  {
    path: "/report-viewer/:reportId?",
    name: "Report Viewer",
    component: () => import('@/pages/report/ReportViewer.vue'),
    meta: {
      breadcrumb: [{ label: 'Report Viewer' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view'
    }
  },
  {
    path: "/report-pdf/:reportId?",
    name: "Report PDF",
    component: () => import('@/pages/report/ReportPDF.vue'),
    meta: {
      breadcrumb: [{ label: 'Report PDF' }],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view'
    }
  },

]
